class UaLogger {
	#consoleLog(log: () => void) {
		// Only log to console in lower environments
		if (globalThis.uaOkta?.environment === 'preview') {
			log()
		}
	}

	constructor() {}

	debug(message: string, context?: object): void {
		// Only debug during local
		if (globalThis.uaOkta?.environment === 'preview' && globalThis.uaOkta?.version === 'DEVELOPMENT') {
			this.#consoleLog(() => console.debug(message, context))
		}
	}

	error(message: string, context?: object): void {
		this.#consoleLog(() => console.error(message, context))
	}

	info(message: string, context?: object): void {
		this.#consoleLog(() => console.info(message, context))
	}

	warn(message: string, context?: object): void {
		this.#consoleLog(() => console.warn(message, context))
	}
}

export default new UaLogger()
